import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined'
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FileRepositoryModel } from 'src/models/file-repository-model'

interface DeleteEntryModalProps {
  open: boolean
  entry: FileRepositoryModel | null
  onClose: () => void
  onDelete: (id: string, name: string) => Promise<any>
}

export function DeleteEntryModal({
  open,
  entry,
  onClose,
  onDelete,
}: DeleteEntryModalProps) {
  const { t } = useTranslation()
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = async () => {
    if (!entry) return
    setIsDeleting(true)
    const res = await onDelete(entry.id, entry.name)
    setIsDeleting(false)
    if (res) {
      onClose()
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('fileRepository.modal.delete.title')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('fileRepository.modal.delete.message', { name: entry?.name })}
        </Typography>
        {entry?.type === 'DIRECTORY' && (
          <Box
            sx={{
              mt: 2,
              p: 1.5,
              backgroundColor: 'rgba(255, 152, 0, 0.08)',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <WarningAmberOutlined sx={{ color: 'warning.main' }} />
            <Typography variant="body2" color="text.secondary">
              {t('fileRepository.modal.delete.directoryWarning')}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('general.button.cancel')}</Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleDelete}
          disabled={isDeleting}
        >
          {isDeleting ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            t('fileRepository.modal.delete.button')
          )}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
